import React from "react";
import { VStack, Box, Button, Flex } from "@chakra-ui/react";
import { useTranslation, Trans } from "react-i18next";
import ErrorMsg from "../common/ErrorMsg";

import { ChevronLeftIcon, CloseIcon } from "@chakra-ui/icons";

export const RuleErrors = (ruleId, t, values = {}) => {
  switch (true) {
    case ruleId === "Radianse.RulesEngine.Core.Active":
      return t(
        "error.unable_to_schedule",
        "Unable to schedule your appointment at this time, please see a Staff member for more information."
      );
    case ruleId === "Radianse.RulesEngine.Core.InGoodStanding":
      return t(
        "error.unable_to_schedule",
        "Unable to schedule your appointment at this time, please see a Staff member for more information."
      );
    case ruleId === "Radianse.RulesEngine.Core.MinimumAge":
      return t(
        "error.minimum_age_requirement",
        "Your member profile does not meet the minimum age requirement. Please see a Staff member for more information."
      );
    case ruleId.indexOf("Radianse.RulesEngine.Core.TimeRestriction") !== -1:
      return t("error.time_restriction", {
        count: Number(values.MaximumOccurancesPerTimespan),
        minutes: values.RestrictionTimeInMinutes,
      });
    case ruleId === "Radianse.RulesEngine.Core.RateLimited":
      return t("error.rate_limit", {
        count: Number(values.RestrictionLimitFrequency),
        minutes: values.RestrictionLimitInMinutes,
      });
    case ruleId === "Radianse.RulesEngine.Core.ServicesConfigRule":
      return t(
        "error.member_type_requirement",
        "Your membership does not include access to this feature. Please see a Staff member for more information."
      );
    case ruleId === "Radianse.RulesEngine.Core.MemberType":
      return t(
        "error.member_type_requirement",
        "Your member type does not currently allow access to to your selection. Please see a Staff member for more information."
      );
    default:
      return t(
        "error.please_see_staff",
        "Please see a staff member for assistance."
      );
  }
};

export const RuleError = ({ ruleId, values, onCancel, onBack }) => {
  const { t } = useTranslation();
  const validationError = RuleErrors(ruleId, t, values);
  return (
    <VStack
      color={"#fff"}
      direction={"column"}
      alignItems={"start"}
      flex={1}
      h={"full"}
      spacing={5}
    >
      <Flex
        m={30}
        flex={1}
        w={"full"}
        direction={"column"}
        px={[10, 15, 20, 25, 30]}
        overflow={"hidden"}
        position={"relative"}
      >
        <ErrorMsg message={validationError} />
      </Flex>
      <Box display={"grid"} gridTemplateColumns={"auto auto"} w={"full"}>
        <Button
          justifySelf={"start"}
          variant={"kioskGhost"}
          aria-label={"Back"}
          onClick={onBack || onCancel}
          leftIcon={<ChevronLeftIcon boxSize={10} />}
          data-testid={"back-button"}
        >
          <Trans i18nKey={"actions.back"}>Back</Trans>
        </Button>
        <Button
          justifySelf={"end"}
          variant={"kioskGhost"}
          aria-label={"cancel"}
          onClick={onCancel}
          data-testid={"cancel-button"}
          leftIcon={<CloseIcon boxSize={5} />}
        >
          <Trans i18nKey={"actions.cancel"}>Cancel</Trans>
        </Button>
      </Box>
    </VStack>
  );
};
